$(() => {
	$('#invite_cc_users').select2({
        placeholder: 'CC送信するユーザーを選択して下さい',
        allowClear: true,
		width: '100%',
	});
	var params = $('#invite_cc_users').data('init');
	if (params) {
		// paramsが1件の場合、数値になってしまうのでtoString()する
		$('#invite_cc_users').val(params.toString().split(',')).trigger('change');
	}

	$('#entry_cc_users').select2({
		placeholder: 'CC送信するユーザーを選択して下さい',
		allowClear: true,
		width: '100%',
	});
	var params = $('#entry_cc_users').data('init');
	if (params) {
		// paramsが1件の場合、数値になってしまうのでtoString()する
		$('#entry_cc_users').val(params.toString().split(',')).trigger('change');
	}
});
